import React from 'react';
import SideMenuItem from '../SidemenuItems/SideMenuItem';
import { Div } from '../../../../components/grid';
import { SideMenuSpacer } from '../SidemenuItems';

export default ({
  activeSidemenu,
}) => (
  <Div>
    <SideMenuItem to="/leverandoer-sodavand-kildevand-oel" title="Din leverandør af sodavand, kildevand & øl" active={activeSidemenu === 'Leverandoer'} main />
    <SideMenuSpacer />
    <SideMenuItem to="/oel" title="Køb øl online" active={activeSidemenu === 'Oel'} main />
    <SideMenuItem to="/oel/daaseoel" title="Dåseøl" active={activeSidemenu === 'Daaseoel'} />
    <SideMenuItem to="/oel/flaskeoel" title="Flaskeøl" active={activeSidemenu === 'Flaskeoel'} />
    <SideMenuItem to="/oel/alkoholfri-oel" title="Alkoholfri Øl" active={activeSidemenu === 'Alkoholfri'} />
    <SideMenuItem to="/vin" title="Vin" active={activeSidemenu === 'Vin'} />
    <SideMenuItem to="/alkoholsodavand" title="Alkoholsodavand" active={activeSidemenu === 'AlkoholSodavand'} />
  </Div>
);
